import { combineReducers } from 'redux';
import { authentication } from './authentication'
import { registration } from './registration'
import { user } from './user'
import { queries } from './queries'
import { sports } from './sports'
import { picks } from './picks'
import { pipeline } from './pipeline'

const rootReducer = combineReducers({
	authentication,
	registration,
  user,
	queries,
	sports,
	picks,
	pipeline
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/_reducers/index.js